import { Button, Typography } from '@mui/material';
import cn from 'classnames';
import React, { FC } from 'react';

import { ReceivingMethod } from '../../../../api/def_common_api';

import styles from './CheckoutYourOrder.module.sass';
import { useYourOrder } from './useYourOrder';

const CheckoutYourOrder: FC = () => {
  const { order } = useYourOrder();

  return (
    <div className={styles.order}>
      <div className={styles.wrapper}>
        <Typography variant="h5" fontWeight={700}>
          Ваш заказ
        </Typography>
        <div className={styles.block}>
          <div className={cn(styles.total, styles.first)}>
            <div className={styles.product}>Товары ({order.orderQuantity})</div>
            <div className={styles.dotted}></div>
            <div className={styles.price}>{order.orderSum} ₽</div>
          </div>
          <div className={cn(styles.total, styles.second)}>
            <div className={styles.product}>Стоимость доставки</div>
            <div className={styles.dotted}></div>
            <div className={styles.price}>
              {order.typeDelivery === ReceivingMethod.SelfDelivery
                ? '0'
                : order.priceDelivery}{' '}
              ₽
            </div>
          </div>
          <div className={cn(styles.total, styles.third)}>
            <div className={styles.itog}>Итого</div>
            <div className={styles.dotted}></div>
            <div className={styles.itogPrice}>{order.totalPrice} ₽</div>
          </div>
        </div>
        <Button
          className={styles.button}
          type="submit"
          variant="orange"
          color="primary"
          fullWidth
        >
          Подтвердить заказ
        </Button>
        <div className={styles.policy}>
          <p>
            Подтверждая заказ, Вы соглашаетесь{' '}
            <span>
              с условиями политики конфиденциальности и правилами продажи
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CheckoutYourOrder;
